// Static config + mock data for the homepage Feature Showcase carousel.
// All data here is local-only — the homepage demos NEVER hit a real API.

export const SECTION_COPY = {
  heading: "Automate Conversations. Understand Your Audience. Grow Faster.",
  subheading:
    "Powerful tools built for brands and influencers to automate Instagram comments and DMs, analyze audience sentiment, and turn every comment into a real business result.",
};

// Each slide drives FeatureSlide (left content) + RunningDemo (right demo).
export const SLIDES = [
  {
    id: "comment-automation",
    eyebrow: "Comment → DM Automation",
    title: "Comment-Triggered DM Automation",
    description:
      "Upload a post or reel and automate it on Infuber. When someone comments your keyword, we check if they follow you — non-followers are guided to follow, then the product link is delivered in their DMs automatically.",
    cta: { label: "Explore Automation", to: "/influencer/dashboard/automation-dashboard" },
    demo: "chat",
    accent: "orange",
  },
  {
    id: "sentiment-analytics",
    eyebrow: "Powered by Gemini",
    title: "Comment Sentiment Analytics",
    description:
      "Understand audience emotions instantly with AI sentiment detection — turn thousands of comments into clear, actionable insight.",
    cta: { label: "View Analytics", to: "/influencer/dashboard/automation-dashboard" },
    demo: "analytics",
    accent: "blue",
  },
  {
    id: "for-brands",
    eyebrow: "For Brands",
    title: "Built for Brands",
    description:
      "Turn Instagram engagement into a pipeline — every keyword comment is captured, qualified through a follower check, and converted into a lead automatically.",
    cta: { label: "See Brand Workflow", to: "/brands" },
    demo: "workflow",
    accent: "orange",
  },
  {
    id: "for-influencers",
    eyebrow: "For Creators",
    title: "Built for Influencers",
    description:
      "A creator command center — automate comment replies and DMs, grow followers with the follow-gate, and understand your audience from one dashboard.",
    cta: { label: "Explore Creator Tools", to: "/influencer" },
    demo: "creator",
    accent: "blue",
  },
];

// --- Slide 1: comment-triggered DM automation w/ follower gate (loops) -------
// Mirrors the real flow: keyword comment -> follower check -> guide non-follower
// to follow -> deliver product link in DM. All simulated (no API).
export const CHAT_CONTACT = {
  name: "John",
  handle: "@john_travels",
};

export const CHAT_PRODUCT = {
  title: "Safari Pentagon Pro 8 Wheels Spinner Cabin Trolley Bag, 360° Wheeling Carry on Luggage, 55 cm",
  rating: 4.2,
  reviews: "33,937",
  link: "amzn.in/d/01vH7zFi",
};

export const CHAT_SCRIPT = [
  { id: 1, type: "trigger", text: 'Commented "LINK" on your reel' },
  {
    id: 2,
    type: "bot",
    text: "Hey there! Glad you're here 😊 Tap below and I'll send you the access in just a moment ✨",
    button: "Send me the Access",
  },
  { id: 3, type: "user", text: "Send me the Access" },
  { id: 4, type: "check", text: "Checking follow status…", result: "Not following yet" },
  {
    id: 5,
    type: "bot",
    text: "Almost there! Please visit my profile and tap follow to continue.",
    buttons: ["Visit profile & follow", "I'm Following ✅"],
  },
  { id: 6, type: "user", text: "I'm Following ✅" },
  { id: 7, type: "check", text: "Verifying follow…", result: "Follower confirmed ✓", ok: true },
  { id: 8, type: "product" },
  {
    id: 9,
    type: "bot",
    text: "Hi John, thanks for your interest in our product. Here's the product link 🔗",
    link: true,
  },
];

// --- Slide 2: sentiment analytics (mirrors CommentAnalysis model fields) ------
export const SENTIMENT = {
  positiveCount: 1284,
  neutralCount: 412,
  negativeCount: 96,
  sentimentScore: 87, // 0-100
  engagementQuality: "High", // Low | Medium | High
  persona: "Loyal Super-Fans",
  topThemes: ["Product quality", "Fast shipping", "Link requests"],
  insights: [
    "Positive mentions up 32% week over week",
    "Most asked: “share the link please”",
  ],
};

// --- Slide 3: brand workflow (animated connectors) ---------------------------
// Mirrors the real comment -> follower-gate -> auto-DM -> conversion flow.
export const WORKFLOW_STEPS = [
  { id: "comment", label: "Keyword Comment", icon: "comment" },
  { id: "match", label: "Keyword Match Detected", icon: "brain" },
  { id: "follow", label: "Follower Check & Gate", icon: "users" },
  { id: "dm", label: "Auto DM Sent", icon: "send" },
  { id: "link", label: "Product Link Delivered", icon: "database" },
  { id: "lead", label: "Lead & Sale Captured", icon: "trending" },
];

// --- Slide 4: creator dashboard ----------------------------------------------
export const CREATOR_METRICS = [
  { id: "followers", label: "Followers", value: 248000, suffix: "", format: "compact" },
  { id: "engagement", label: "Engagement Rate", value: 7.4, suffix: "%", format: "decimal" },
  { id: "comments", label: "Comments Automated", value: 24600, suffix: "", format: "compact" },
  { id: "positive", label: "Positive Audience", value: 92, suffix: "%", format: "int" },
  { id: "dms", label: "Auto DMs Sent", value: 18420, suffix: "", format: "compact" },
];

export const CREATOR_FEED = [
  { id: 1, text: 'Keyword "LINK" matched on a reel', tag: "auto" },
  { id: 2, text: "Follower gate passed by @john_travels", tag: "lead" },
  { id: 3, text: "Product link delivered in DM", tag: "deal" },
  { id: 4, text: "Sentiment trending positive 😊", tag: "insight" },
  { id: 5, text: "Gained 3 new followers", tag: "growth" },
];
